/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GeneratePdfResponse,
  GeneratePdfRequest,
  GeneratePdfByPeriodResponse,
  UtxPdfGeneratorGenerateByPeriodParams
} from './schema'



export const utxPdfGeneratorGenerate = (
    generatePdfRequest: GeneratePdfRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GeneratePdfResponse>> => {
    return axios.post(
      `/pdf-client/generate`,
      generatePdfRequest,options
    );
  }



    export type UtxPdfGeneratorGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof utxPdfGeneratorGenerate>>>
    export type UtxPdfGeneratorGenerateMutationBody = GeneratePdfRequest
    export type UtxPdfGeneratorGenerateMutationError = AxiosError<unknown>

    export const useUtxPdfGeneratorGenerate = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPdfGeneratorGenerate>>, TError,{data: GeneratePdfRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPdfGeneratorGenerate>>, {data: GeneratePdfRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPdfGeneratorGenerate(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPdfGeneratorGenerate>>, TError, {data: GeneratePdfRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxPdfGeneratorGenerateByPeriod = (
    params: UtxPdfGeneratorGenerateByPeriodParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GeneratePdfByPeriodResponse>> => {
    return axios.get(
      `/pdf-client/generate-by-period`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxPdfGeneratorGenerateByPeriodQueryKey = (params: UtxPdfGeneratorGenerateByPeriodParams,) => [`/pdf-client/generate-by-period`, ...(params ? [params]: [])];

    
export type UtxPdfGeneratorGenerateByPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof utxPdfGeneratorGenerateByPeriod>>>
export type UtxPdfGeneratorGenerateByPeriodQueryError = AxiosError<unknown>

export const useUtxPdfGeneratorGenerateByPeriod = <TData = Awaited<ReturnType<typeof utxPdfGeneratorGenerateByPeriod>>, TError = AxiosError<unknown>>(
 params: UtxPdfGeneratorGenerateByPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxPdfGeneratorGenerateByPeriod>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxPdfGeneratorGenerateByPeriodQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxPdfGeneratorGenerateByPeriod>>> = ({ signal }) => utxPdfGeneratorGenerateByPeriod(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxPdfGeneratorGenerateByPeriod>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

